import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredUser } from '../api';

/**
 * Guards a route by role.
 *
 * Rules:
 *  - No token/user      -> redirect to /login
 *  - role='agent' on an admin-only route -> redirect to /agent
 *  - role='admin' on an agent-only route -> redirect to /
 *  - Otherwise render children.
 *
 * @param {{ allow: 'admin'|'agent', children: React.ReactNode }} props
 */
export default function ProtectedRoute({ allow, children }) {
  const user = getStoredUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allow === 'admin' && user.role !== 'admin') {
    // Agents trying to reach admin pages go to their dashboard.
    return <Navigate to="/agent" replace />;
  }

  if (allow === 'agent' && user.role !== 'agent') {
    // Admins landing on agent pages go to the admin overview.
    return <Navigate to="/" replace />;
  }

  return children;
}
